import React from 'react';
import { Title } from 'bloomer/lib/elements/Title';
import Bold from '../Bold';
import { Box } from 'bloomer/lib/elements/Box';
import { Image } from 'bloomer/lib/elements/Image';
import styled from 'styled-components';

const VertialCenter = styled.div<any>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ReportTitle = ({ startDate, endDate }: { startDate: string; endDate: string }) => (
  <Box className="on-print-own-page">
    <VertialCenter>
      <Image src="https://www.markwilkins.co/public/assets/logo.svg" alt="By. Mark Wilkins" isSize="128x128" />
      <Title tag="h3">Enrichment Report</Title>
      <p className="has-text-centered">
        {startDate} to {endDate}
      </p>
      <p>
        <Bold>NOTICE: </Bold>This report is generated automatically. To make it more readable, very large decimals have
        been rounded to the nearest whole number, percantages to two decimal places. As a result, percentages are{' '}
        <Bold>approximate</Bold>.{' '}
      </p>
    </VertialCenter>
  </Box>
);

export default ReportTitle;
